<div class="repricing" *ngIf="params.data.Prmodel" (click)="prevent($event)">
  <div
    class="repricing_model-name"
    [ngStyle]="{ color: !params.data.PricingOn ? 'darkgray' : '' }"
    [matTooltip]="params.data.PricingOn ? '' : 'SKU is turned off'"
  >
    {{ params.data.PriceModelName }}
  </div>
  <!-- <div class="repricing_paused" *ngIf="!params.value.isActive">
    Paused
  </div> -->
  <div
    class="repricing_icon"
    [matTooltip]="
      params.data.IsRepricing ? 'Repricer is active' : 'Repricer is not active'
    "
    [ngClass]="
      params.data.IsRepricing ? 'repricing_icon--on' : 'repricing_icon--off'
    "
  ></div>
</div>

<app-button
  [buttonSize]="'action'"
  (click)="startEditing($event,params)"
  [buttonStyle]="'wire'"
  *ngIf="!params.data.Prmodel"
  >Add Repricing Model</app-button
>
